// extracted by mini-css-extract-plugin
export default {"subcontainer":"perLanguage_subcontainer__zI0Vf","title":"perLanguage_title__7vaT4","tooltipContent":"perLanguage_tooltipContent__AySOx"};